<template>
  <div class="app-layout over-hidden-x">
    <!-- 顶部搜索的表单 -->
    <div class="top-search" v-loading="queryLoading">
      <el-form
        align="left"
        size="small"
        ref="topForm"
        :model="formQuery"
        label-width="80px"
        :inline="true"
        class="padding-left-20"
      >
        <el-form-item label="时间范围">
          <el-date-picker v-model="formQuery.range" type="daterange" range-separator="至"
            start-placeholder="开始日期" end-placeholder="结束日期" align="right" unlink-panels
            :clearable="false"></el-date-picker>
        </el-form-item>
        <el-form-item label="系统">
          <el-select @change="osInfosChange" v-model="formQuery.os" placeholder="请选择系统">
            <el-option v-for="item in osInfos" :key="item.os" :label="item.os"
              :value="item.value === undefined ? item.os : item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="版本">
          <el-select @change="handleQueryData" v-model="formQuery.osVersion" placeholder="请选择版本"
            clearable>
            <el-option v-for="(item, index) in osVersions" :key="`osVersion-${index}`"
              :label="item.os === undefined ? item : item.os"
              :value="item.value === undefined ? item : item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-button size="small" type="primary" @click="handleQueryData">查询</el-button>
      </el-form>
    </div>
    <el-card class="box-card" shadow="never">
      <div class="container"
        ref="container"
      >

        <div class="container-title">
          <div
            class="container-title-item"
            v-for="(item) in groups"
            :key="item.id"
            :style="{ width: `${groupWidth}px` }"
          >
            <span>{{ item.label }}</span>
          </div>
        </div>

        <div
          id="container"
          :style="{ width: `${containerWidth}px`, height: `${containerHeight}px`, }"
        ></div>
      </div>
    </el-card>
  </div>
  </template>
<script>
/* eslint-disable no-param-reassign */
import G6 from '@antv/g6';
import Moment from 'moment';
import { mapGetters } from 'vuex';
import { cloneDeep } from 'lodash';
// import { Message } from 'element-ui';
import { queryOsInfo, queryEventTraceAnalyzeSummary } from '@/api/event';
import EventNode from './node/event';

export default {

  computed: {
    ...mapGetters('app', ['env', 'source']),
  },

  data() {
    return {
      activeName: 0,
      queryLoading: false,
      osInfos: [],
      osVersions: [],
      formQuery: {
        id: '',
        range: [],
        osVersion: '',
        eventCode: '',
        os: '',
      },
      routerInfo: {
        traceName: '',
        traceDesc: '',
      },
      graph: null,
      value: '',

      isProcessing: false,
      eventDialogVisible: false,
      edgeAdding: false,
      containerMinWidth: 1200, // 容器最小的宽度
      containerWidth: 1200, // 容器的宽度
      containerHeight: 500, // 容器的高度
      groupWidth: 240, // 一组的宽度
      groupHeight: 80, // 一个事件高度
      groupLineWidth: 5, // 分割线的宽度
      eventNodeWidth: 120, // 事件节点的宽度

      insertEvent: null, // 待插入的事件
      // insertIndex: null, // 待插入的事件的序号

      dargEvent: null,

      lineColor: ['rgb(95, 204, 144)', 'rgb(103, 193, 186)', 'rgb(104, 177, 229)', 'rgb(86, 146, 238)', 'rgb(248, 204, 198)', 'rgb(64, 158, 255)', 'rgb(103, 194, 58)'], // 创建的分界线的颜色

      // 分组
      groups: [],

      // 所有的事件列表
      cacheEvents: [],

      // 当前事件
      events: [],

      // 节点
      nodes: [],

      datasNode: [],
    };
  },
  watch: {
    source: {
      handler() {
        this.queryOsInfo();
      },
    },
    env: {
      handler() {
        this.queryOsInfo();
      },
    },
  },
  methods: {
    async queryOsInfo() {
      this.queryLoading = true;
      try {
        const { range } = this.formQuery;
        const data = {
          analyzeTimeTo: `${Moment(range[1]).format('YYYY-MM-DD')}`,
          analyzeTimeFrom: `${Moment(range[0]).format('YYYY-MM-DD')}`,
        };
        const {
          data: { osInfos },
        } = await queryOsInfo(data);

        const index = osInfos.findIndex((item) => item.os === '');
        if (index > -1) {
          osInfos.splice(index, 1);
        }
        this.osInfos.splice(
          0,
          this.osInfos.length,
          // eslint-disable-next-line comma-dangle
          ...[{ os: '全部', value: '' }, ...osInfos]
        );

        this.formQuery.os = '';
        this.osInfosChange();
      } catch (error) {
        console.error(error);
      } finally {
        this.queryLoading = false;
      }
    },
    osInfosChange() {
      const filterData = this.osInfos.filter(
        // eslint-disable-next-line comma-dangle
        (item) => item.os === this.formQuery.os
      );

      const [{ osVersions = [] }] = filterData.length
        ? filterData
        : [{ osVersions: [] }];

      this.formQuery.osVersion = '';
      this.osVersions.splice(
        0,
        this.osVersions.length,
        // eslint-disable-next-line comma-dangle
        ...[{ os: '全部', value: '' }, ...osVersions]
      );

      this.handleQueryData();
    },
    async handleQueryData() {
      this.queryLoading = true;
      try {
        // eslint-disable-next-line object-curly-newline
        const {
          range,
          osVersion,
          os,
          id,
        } = this.formQuery;

        const data = {
          analyzeTimeTo: `${Moment(range[1]).format('YYYY-MM-DD')} 23:59:59`,
          analyzeTimeFrom: `${Moment(range[0]).format('YYYY-MM-DD')} 00:00:00`,
          osVersion,
          os,
          id,
        };
        const {
          data: { summaryList },
        } = await queryEventTraceAnalyzeSummary(data);

        const {
          // groups,
          lineColor,
        } = this;

        let maxGroup = 0;
        summaryList.forEach((item) => {
          item.group = item.groupSeq;
          item.id = item.eventCode;
          maxGroup = Math.max(maxGroup, +item.group);
        });
        this.groups.splice(0);
        new Array(maxGroup + 1).fill('').forEach((item, index) => {
          this.groups.push({
            label: `第${index + 1}组`,
            id: index,
            color: lineColor[index],
          });
        });
        this.nodes.splice(0);
        this.nodes.push(...summaryList);

        if (this.graph) {
          this.graph.destroy();
          this.graph = null;
        }
        this.init();
        this.resetCanvas();
      } catch (error) {
        console.error(error);
      } finally {
        this.queryLoading = false;
      }
    },
    /**
       * 计算可以插入的位置
       */
    getInsertLastNode(lastNode, groups = []) {
      if (!lastNode || !groups) {
        return null;
      }

      if (!groups.length) {
        return null;
      }

      // 计算可以插入的位置
      groups.sort((a, b) => a.y - b.y);

      const groupYs = groups.map((group) => group.y);

      // 最小y大于120，表示首个位置依然可以插入
      if (Math.min(...groupYs) > 120) {
        return null;
      }

      // 判断每个数字之间是否是60的差距，如果不是，返回坐标
      let start = 0;
      let next = 1;
      let index = null;

      // 因为不是按照顺序排列，所以有可能存在插入位置不准确的问题，所以需要对数据进行
      while (start < groupYs.length && groupYs[start] && groupYs[next]) {
        if (groupYs[next] - groupYs[start] !== 60) {
          index = start;
          break;
        } else {
          start++;
          next++;
        }
      }
      return index !== null ? groups[index] : ((groups[groups.length - 1]) || lastNode);
    },
    /**
       * 线段到最前面
       */
    edgesToFront() {
      const edges = this.graph.getEdges();
      edges.forEach((edge) => {
        edge.toFront();
      });
    },

    /**
       * 计算事件节点的x方向
       */
    calcEventNodeX(groupIndex = 0) {
      return (
        (this.groupWidth * (groupIndex + 1)) - (this.eventNodeWidth + (this.eventNodeWidth / 2))
      );
    },

    /**
       * 计算事件节点的y方向
       */
    calcEventNodeY(lastNode) {
      return lastNode?.y ? lastNode.y + 60 : 120;
    },

    /**
       * 创建节点
       */
    createNode(item, lastNode) {
      const { group: groupIndex } = item;
      return {
        type: 'event',
        id: item.eventCode,
        // eslint-disable-next-line max-len
        // x: ((this.groupWidth * (groupIndex + 1)) - (this.groupWidth / 2)) - (((item.label.length + 1) * 15) / 2),
        x: this.calcEventNodeX(groupIndex),
        y: this.calcEventNodeY(lastNode) + 20,
        label: item.eventName,
        codeLabel: item.eventCode,
        item,
        style: {
          fill: 'rgb(211, 223, 229)',
          stroke: '#888',
          lineWidth: 1,
          radius: 4,
          fontSize: 12,
        },
        group: groupIndex,
        size: 28,
        ellipsis: this.groups.length > 1 && (groupIndex !== this.groups.length - 1), // 要不要省略号
        linkPoints: {
          top: false,
          bottom: false,
          left: false,
          right: false,
        },
      };
    },

    /**
       * 创建分组
       */
    createGroup({ id, color }, index) {
      return {
        id: `${id}`,
        type: 'rect',
        x: index * this.groupWidth + (this.groupLineWidth / 2),
        y: 0,
        label: '',
        draggable: false,
        labelStyle: {
          fontSize: 12,
        },
        style: {
          fill: color,
          lineWidth: 0,
        },
        size: [
          this.groupLineWidth,
          this.containerHeight * 2,
        ],
        color: '#333',
      };
    },
    reRender() {
      this.graph.clear();
      this.graph.read(cloneDeep(this.graph.save()));
      this.graph.render();
    },
    /**
       * 重置容器宽度
       */
    resetCanvas() {
      // nodes groups
      let max = 0;
      const { length } = this.groups;
      if (this.nodes.length) {
        const nodesGoupsStr = this.nodes.map((item) => item.group).join(',');
        new Array(length).fill('').forEach((item, index) => {
          const matchLen = String(nodesGoupsStr).match(new RegExp(`${index}`, 'g'))?.length || 0;
          max = max > matchLen ? max : matchLen;
        });
      }
      const width = length * this.groupWidth;
      const height = max * this.groupHeight;

      // console.log(this.containerHeight, height, max);
      this.containerHeight = height < this.containerHeight ? this.containerHeight : height;
      this.containerWidth = width < this.containerMinWidth ? this.containerMinWidth : width;
      this.graph.changeSize(this.containerWidth, this.containerHeight);

      this.groups.forEach(({ id }) => {
        this.graph.updateItem(this.graph.findById(id), this.createGroup(
          {
            id,
            color: this.lineColor[id],
          },
          id,
        ));
      });
    },

    /**
       * 初始化图表
       */
    init() {
      if (this.graph) {
        return;
      }

      // G6.registerBehavior('click-add-edge', clickAddEdge);
      G6.registerNode('event', EventNode, 'rect');

      const dashArray = [
        [0, 1],
        [0, 2],
        [1, 2],
        [0, 1, 1, 2],
        [0, 2, 1, 2],
        [1, 2, 1, 2],
        [2, 2, 1, 2],
        [3, 2, 1, 2],
        [4, 2, 1, 2],
      ];
      const lineDash = [4, 2, 1, 2];
      const interval = 9; // lineDash 的总长度。

      // 注册名为 'can-running' 的边
      G6.registerEdge(
        'can-running',
        {
          // 复写setState方法
          setState(name, value, item) {
            const shape = item.get('keyShape');
            // 监听 running 状态
            if (name === 'running') {
              // running 状态为 true 时
              if (value) {
                const length = shape.getTotalLength();
                let totalArray = [];
                for (let i = 0; i < length; i += interval) {
                  totalArray = totalArray.concat(lineDash);
                }
                let index = 0;
                shape.animate(
                  {
                    // 动画重复
                    repeat: true,
                    // 每一帧的操作，入参 ratio：这一帧的比例值（Number）。返回值：这一帧需要变化的参数集（Object）。
                    onFrame() {
                      const cfg = {
                        lineDash: dashArray[index].concat(totalArray),
                      };
                      index = (index + 1) % interval;
                      return cfg;
                    },
                  },
                  10000,
                ); // 一次动画的时长为 3000
              } else {
                // running 状态为 false 时
                // 结束动画
                shape.stopAnimate();
                // 清空 lineDash
                shape.attr('lineDash', null);
              }
            }
          },
        },
        'cubic-horizontal',
      ); // 该自定义边继承了内置横向三阶贝塞尔曲线边 cubic-horizontal

      this.graph = new G6.Graph({
        container: 'container',
        width: this.containerWidth,
        height: this.containerHeight,
        groupByTypes: false,
        animate: true, // Boolean，切换布局时是否使用动画过度，默认为 false
        animateCfg: {
          duration: 10000, // Number，一次动画的时长
          easing: 'linear', // String，动画函数，可选项：''
        },
        modes: {
          default: [
            // {
            //   type: 'zoom-canvas',
            // },
            { type: 'activate-relations', activeState: 'active', inactiveState: 'inactive' },
            {
              type: 'tooltip',
              formatText(model) {
                return `<p style="text-align: left">${model.label}<br />${model.codeLabel}</p>`;
              },
              offset: 30,
              shouldBegin: (e) => e.target.cfg.type === 'text',
            },
          ],
        },
        defaultEdge: {
          type: 'cubic-horizontal',
          lineWidth: 1,
          style: {
            endArrow: true,
            stroke: '#FAD069',
          },
        },
      });

      // const that = this;

      // 监听节点的 mouseenter 事件
      this.graph.on('node:mouseenter', (ev) => {
        // 获得当前鼠标操作的目标节点
        const { item, item: { _cfg: { model } } } = ev;
        if (model.type === 'event') {
          // 获得目标节点的所有相关边
          const edges = item.getEdges();
          // 将所有相关边的 running 状态置为 true，此时将会触发自定义节点的 setState 函数
          edges.forEach((edge) => {
            this.graph.setItemState(edge, 'running', true);
            // edge.toFront();
          });
        }
      });
      this.graph.on('node:click', (ev) => {
        this.deleteNodes();
        // 获得当前鼠标操作的目标节点

        const {
          item,
          item: {
            _cfg: {
              // id: currentId,
              model,
              // model: {
              //   group,
              // },
            },
          },
        } = ev;

        if (model.type === 'event') {
          // 获得目标节点的所有相关边
          const edges = item.getEdges();
          // 将所有相关边的 running 状态置为 true，此时将会触发自定义节点的 setState 函数
          edges.forEach((edge) => {
            // const id = G6.Util.uniqueId();
            // const {
            //   _cfg: {
            //     target, // 结束点 id
            //     target: {
            //       _cfg: targetCfg,
            //     },
            //     source,
            //     source: {
            //       _cfg: sourceCfg,
            //     },
            //   },
            // } = edge;
            // const {
            //   // id: targetId,
            //   model: {
            //     label,
            //     // item: {
            //     //   eventCode,
            //     // },
            //   },
            // } = targetCfg;
            // const {
            //   id: sourceId,
            //   // model: {
            //   //   label: sourceLabel,
            //   // },
            // } = sourceCfg;
            // console.log(currentId);
            // console.log(sourceId, sourceLabel, '=>', targetId, label);
            // const box = (currentId === sourceId ? target : source);
            // const boxInfo = box.getBBox();
            // // eslint-disable-next-line no-underscore-dangle
            // const itemInfo = box._cfg.model.item;
            // this.datasNode.push(id);

            // this.graph.addItem('node', {
            //   x: boxInfo.maxX + boxInfo.width,
            //   y: boxInfo.minY,
            //   type: 'modelRect',
            //   zIndex: 10,
            //   label,
            //   description: `事件: ${itemInfo.eventCount || 0}\n用户: ${itemInfo.userCount || 0}`,
            //   labelCfg: {
            //     style: {
            //       fontSize: 12,
            //     },
            //     offset: 10,
            //   },
            //   logoIcon: {
            //   // 是否显示icon，值为 false 则不渲染icon
            //     show: false,
            //   },
            //   // 节点中表示状态的icon配置
            //   stateIcon: {
            //   // 是否显示icon，值为 false 则不渲染icon
            //     show: false,
            //   },
            //   temporary: true,
            //   id, // Generate the unique id
            // });

            this.graph.setItemState(edge, 'running', true);
          });
        }

        // eslint-disable-next-line no-underscore-dangle
        // console.log(item._cfg);
        // const subData = '???'; // res是后台返回的数据

        // // eslint-disable-next-line no-underscore-dangle
        // const el = this.graph.findById(item._cfg.id);

        // console.log(el, '??');

        // // eslint-disable-next-line no-underscore-dangle
        // el._cfg.model.label = subData;

        // this.graph.refreshItem(el);

        // this.graph.render();
      });
      // 监听节点的 mouseleave 事件
      this.graph.on('node:mouseleave', (ev) => {
        // 获得当前鼠标操作的目标节点
        const node = ev.item;
        // 获得目标节点的所有相关边
        const edges = node.getEdges();
        // 将所有相关边的 running 状态置为 false，此时将会触发自定义节点的 setState 函数
        edges.forEach((edge) => this.graph.setItemState(edge, 'running', false));
      });
      this.graph.on('canvas:mouseleave', () => {
        // 获得当前鼠标操作的目标节点
        this.deleteNodes();
      });

      this.render();
    },
    render() {
      const data = {
        nodes: [],
      };

      const groupsNodes = [];

      // 根据节点渲染内容
      this.nodes.forEach((item) => {
        const { group: groupIndex } = item;

        if (!groupsNodes[groupIndex]) {
          groupsNodes[groupIndex] = [];
        }

        const currentGroup = groupsNodes[groupIndex];
        const lastNode = currentGroup[currentGroup.length - 1];

        let currentNode = {};

        if (!lastNode) {
          // 判断属于哪个分组
          currentNode = this.createNode(item, null);
          currentGroup.push(currentNode);
        } else {
          currentNode = this.createNode(item, lastNode);
          currentGroup.push(currentNode);
        }
        data.nodes.push(currentNode);
      });

      // 根据具有的组合绘画分组的边框
      this.groups.forEach((item, index) => {
        data.nodes.push(this.createGroup(item, index));
      });

      const edges = [];
      if (this.groups.length > 1) {
        groupsNodes.forEach((group, index) => {
          if (groupsNodes[index + 1]) {
            group.forEach((item) => {
              groupsNodes[index + 1].forEach((groupsNext) => {
                edges.push({
                  source: item.id,
                  target: groupsNext.id,
                  label: `事件: ${item.eventCount || 0}\n用户: ${item.userCount || 0}`,
                  labelCfg: {
                    position: 'start',
                    refY: -18,
                    refX: 5,
                    style: {
                      stroke: 'white', // 给文本添加白边和白色背景
                      fill: '#33333',
                      opacity: 0.5,
                      fontSize: 10,
                    },
                  },
                  zIndex: 9,
                  type: 'can-running',
                });
              });
              // edges.push()
            });
          }
        });
      }

      this.nodes = data.nodes;

      // this.graph.read(data);
      console.log(data);
      data.edges = edges;
      this.graph.data(data);
      this.graph.render();
    },

    /**
       * 根据html5的拖拽事件获取的坐标，转换为拖拽到的所在组
       */
    getPointToGroup(point) {
      const { x, y } = point;
      if (y < 0) {
        return null;
      }
      return Math.ceil(x / this.groupWidth);
    },
    deleteNodes() {
      this.datasNode.forEach((id) => this.graph.removeItem(id));
      // this.graph.getNodes().forEach((nodeItem) => {
      //   // this.graph.clearItemStates(nodeItem);
      //   const { _cfg: { model, model: { id } } } = nodeItem;
      //   console.log('model.temporary', model.temporary, id);
      //   if (model.temporary) {
      //     this.graph.removeItem(nodeItem);
      //   }
      // });
    },
  },
  beforeDestroy() {
    this.graph = null;
    this.isProcessing = false;
  },
  mounted() {
    this.containerHeight = this.$refs.container.offsetHeight;
    this.containerWidth = this.$refs.container.offsetWidth;
    this.containerMinWidth = this.$refs.container.offsetWidth;
    if (this.$route.query.id) {
      const {
        id, traceName, traceDesc,
      } = this.$route.query;
      this.formQuery.id = id;
      this.routerInfo.traceName = traceName;
      this.routerInfo.traceDesc = traceDesc;
    }

    const today = Moment().format('YYYY-MM-DD');
    const today2 = Moment().subtract(7, 'days').format('YYYY-MM-DD');
    this.formQuery.range = [new Date(today2), new Date(today)];
    this.queryOsInfo();
  },
};
</script>
  <style lang="scss">
  .g6-tooltip {
    padding: 10px 6px;
    color: #444;
    background-color: rgba(255, 255, 255, 0.9);
    border: 1px solid #e2e2e2;
    border-radius: 4px;
    font-size: 12px;
    min-width: 100px;
    z-index: 2;
  }
  </style>
  <style lang="scss" scoped>
  .app-layout {
    min-width: 800px;
    margin: 15px 15px 0;
  }

  .box-card {
    padding: 20px;
  }

  .form {
    text-align: left;
  }

  .events {
    display: flex;
    min-height: 32px;
    align-items: center;
    flex-flow: wrap
  }

  .event {
    display: flex;
    align-items: center;
    min-height: 28px;
    line-height: 22px;
    background: rgb(211, 223, 229);
    font-size: 12px;
    margin-right: 10px;
    padding: 4px 10px;
    border-radius: 3px;
    cursor: move;
  }

  .container {
    position: relative;
    padding: 0;
    max-width: 100%;
    height: calc(100vh - 200px);
    overflow-x: auto;
    overflow-y: hidden;
  }

  .container-title {
    display: flex;
    font-size: 12px;
    color: rgb(184, 184, 184);
    position: relative;
  }

  .container-title-item {
    text-align: left;
    min-width: 240px;
    max-width: 240px;
    position: relative;
  }

  .item-hover {
    position: absolute;
    width: 5px;
    height: 520px;
    z-index: 1;
    top: 0;
    opacity: 0;
  }

  .item-hover-icon {
    font-size: 13px;
    position: relative;
    top: 2;
    left: -3px;
    color: rgb(70, 114, 244);
  }

  .item-hover-bar {
    background: rgb(70, 114, 244);
    display: block;
    width: 5px;
    height: 520px;
  }

  .item-hover-container {
    position: relative;
  }

  #container {
    background: rgb(245, 245, 245);
    overflow: hidden;
  }
  </style>
